import {Box, Grid} from '@material-ui/core'
import Map from 'app/components/map/Map'
import {proposalService} from 'app/services'
import {_} from 'i18n'
import React from 'react'
import {Button} from 'react-bootstrap'
import {useHistory} from 'react-router-dom'

import {ContainerHeader, DetailContainer, Paper} from '../styles'
import {Container} from '../styles'

const ProposaLocation = ({coordinates, location, onSubmit, submiting, handleDrawIndustrialArea}) => {
  return (
    <Container style={{padding: 0}}>
      <Grid container spacing={3}>
        <Grid item lg={12}>
          <Paper id="location">
            <ContainerHeader>{_`Área Industrial do Município`}</ContainerHeader>
            <DetailContainer style={{padding: 0}}>
              {coordinates && coordinates.length && (
                <Map
                  customStyle={{
                    borderRadius: 0,
                    borderBottomLeftRadius: 10,
                    borderBottomRightRadius: 10,
                    width: '100%',
                    margin: 0,
                  }}
                  coordinates={coordinates}
                  zoomIn={13}
                  terrain="satelite"
                  controlOnly="draw"
                  drawArea={location?.industrial_area?.geojson}
                  onChangeDraw={handleDrawIndustrialArea}
                />
              )}
            </DetailContainer>
          </Paper>
        </Grid>
        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}></Grid>
        <Grid item lg={9}>
          <Box display="flex" marginTop="70px" marginBottom="70px">
            <Box mr="20px" style={{maxWidth: 300, width: '100%'}}>
              <Button variant="outline-primary" onClick={() => onSubmit(true)}>
                {_`SALVAR E CONTINUAR EDIÇÃO`}
              </Button>
            </Box>
            <Box>
              <Button onClick={() => onSubmit(false)} disabled={submiting}>
                {_`SALVAR E CONCLUIR EDIÇÃO`}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default ProposaLocation
